.textWithLozenge {
	display: inline-block;
	margin-right: calc(var(--jpo-common-base-spacing) * 0.5);
}
